import PropTypes from 'prop-types';

import React from 'react';
import classNames from 'classnames';
import { Map } from 'immutable';
import Textarea from '../../helpers/Textarea';
import BaseInput from '../../helpers/Input';
import BaseSelect from '../../helpers/Select';
import FormGroup from '../../helpers/FormGroup';
import FormSubmitOnBlur from '../../helpers/FormSubmitOnBlur';
import { InputProps } from '../../helpers/AutoComplete';
import LoadAnimation from '../../decorators/LoadAnimation';
import { Card } from '../../helpers/Card';

import PrettyError from '../../decorators/PrettyError';
import DisplayError from '../../decorators/DisplayError';

import style from './style.module.css';

const Input = PrettyError(DisplayError(BaseInput));
const Select = PrettyError(DisplayError(BaseSelect));

/**
 * Contact LP tab.
 *
 * @param props.onChange {Function} On contact lp changed callback.
 * @param props.contactLP {Immutable.Map}.
 */
const ContactLP = props => {
  const { suggestRelation, onChange, onSubmit, onBlur, contactLP } = props;

  const statuses = contactLP.get('statuses');
  const status = contactLP.get('lpCurrentStatus');
  const highStatus = contactLP.get('lpHighStatus') || '';
  const notes = contactLP.get('lpNotes');

  return (
    <div className={classNames(style.host, 'tab-pane active')} id="slide-4">
      <Card>
        <FormSubmitOnBlur className={style.status} onChange={onChange} onComponentBlur={onBlur} onSubmit={onSubmit}>
          <FormGroup>
            <label className="field-label" htmlFor="contact-lp-relation">
              Primary Relationship
            </label>
            <InputProps
              className="form-control"
              id="contact-lp-relation"
              name="suggestRelation"
              placeholder="Primary Relationship"
            >
              {suggestRelation}
            </InputProps>
          </FormGroup>
          <FormGroup>
            <Select
              id="f-current-status"
              label="Current Status"
              name="lpCurrentStatus"
              onChange={onChange}
              options={statuses}
              value={status}
              showLabel
            />
          </FormGroup>
          <FormGroup>
            <Input
              id="f-high-status"
              label="High Status"
              name="lpHighStatus"
              placeholder="High Status"
              value={highStatus}
              readOnly
              showLabel
            />
          </FormGroup>
        </FormSubmitOnBlur>
      </Card>
      <Card title="Notes">
        <FormSubmitOnBlur onChange={onChange} onComponentBlur={onBlur} onSubmit={onSubmit}>
          <FormGroup className={style.notes}>
            <Textarea
              className="form-control"
              name="lpNotes"
              onChange={onChange}
              placeholder="Notes"
              rows="4"
              value={notes}
            />
          </FormGroup>
        </FormSubmitOnBlur>
      </Card>
    </div>
  );
};

ContactLP.propTypes = {
  contactLP: PropTypes.instanceOf(Map).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default LoadAnimation(ContactLP);
